jQuery(document).ready(function($){

    $(".accordion .benefits-bar").addClass("active");
    $(".accordion .bene-detail-toggle:not(:first)").hide();

    $(".accordion .benefits-bar").click(function(){
        $(this).next(".bene-detail-toggle").slideToggle("500")
        .siblings(".bene-detail-toggle:visible").slideUp("500");
        $(this).toggleClass("active");
        $(this).siblings(".benefits-bar").removeClass("active");
    });
    
    $(".accordion .specifications-bar").addClass("active");
    $(".accordion .bene-detail-toggle:not(:first)").hide();

    $(".accordion .specifications-bar").click(function(){
        $(this).next(".bene-detail-toggle").slideToggle("500")
        .siblings(".bene-detail-toggle:visible").slideUp("500");
        $(this).toggleClass("active");
        $(this).siblings(".specifications-bar").removeClass("active");
    });

    //old responsive tables tweak
    var makeResponsive = function() {
    $('table.old-table-responsive th').each(function(i,elem) {
        var num = i + 1;
        $('table.old-table-responsive td:nth-child(' + num + ')').attr('data-label', $(elem).text());
      });
    };
    makeResponsive();
    $(window).resize(function () {
        makeResponsive();
    });
});